import React, { FC, useContext, useEffect } from 'react';
import LeadsContext from '../../../../providers/Leads/Leads.context';
import Chat from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/pages/Chat';
import MessagingProvider from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/providers/Messaging';
import useMarkSessionRead from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/hooks/useMarkSessionRead';
import { MESSAGE_LOCATION } from 'models/Message';

import './LeadMessages.styles.scss';

const LeadMessages: FC = () => {
  const { selectedLead } = useContext(LeadsContext);

  const { sessionId, unreadMessagesCount } = selectedLead || {};

  const markSessionRead = useMarkSessionRead();

  useEffect(() => {
    if (unreadMessagesCount) markSessionRead(sessionId, false);
  }, [markSessionRead, sessionId, unreadMessagesCount]);

  return (
    <div className="lead-messages">
      <MessagingProvider sessionId={sessionId}>
        <Chat messageLocation={MESSAGE_LOCATION.LEADS_PAGE} />
      </MessagingProvider>
    </div>
  );
};

export default LeadMessages;
